export const USER_ENTITY = "USER";
export const CUSTOMER_ENTITY = "CUSTOMER";
export const FIRM_ENTITY = "FIRM";
export const FIRM_TEAM_ENTITY = "FIRM_TEAM";
export const FIRM_ROLE_ENTITY = "FIRM_ROLE";

export const SUBSCRIPTION_ENTITY = "SUBSCRIPTION";

export const RFQ_ENTITY = "REQUEST";
export const QUOTE_ENTITY = "ESTIMATE";
export const INVOICE_ENTITY = "INVOICE";
